import stalled from "./growth-has-stalled";
import scale from "./ready-to-scale";
import transform from "./reposition-or-transform";
import value from "./create-enterprise-value";

export const SITUATIONS = {
  [stalled.slug]: stalled,
  [scale.slug]: scale,
  [transform.slug]: transform,
  [value.slug]: value,
};
